export default __webpack_public_path__ + "static/media/bulb.0ca8ca52.svg";